export const SUPPORTED_LANGUAGES = [
  {
    code: "de",
    flag: "🇩🇪",
    countryKey: "de",
  },
  {
    code: "en",
    flag: "🇬🇧",
    countryKey: "en",
  },
  {
    code: "pt",
    flag: "🇵🇹",
    countryKey: "pt",
  },
];

export const DEFAULT_LANGUAGE = "en";

export const normalizeLanguage = (rawLanguage) => {
  const input = (rawLanguage || DEFAULT_LANGUAGE).toString().toLowerCase();
  const matched = SUPPORTED_LANGUAGES.find(
    ({ code }) => input === code || input.startsWith(`${code}-`),
  );
  return matched ? matched.code : DEFAULT_LANGUAGE;
};

export const getLanguageOption = (rawLanguage) => {
  const code = normalizeLanguage(rawLanguage);
  return SUPPORTED_LANGUAGES.find((option) => option.code === code) || SUPPORTED_LANGUAGES[0];
};
